import * as flight_log_types from '@journeyapps-platform/types-flight-log';
import { FlightLogClient } from '@journeyapps-platform/sdk-flight-log';
import { TokenStore } from '../stores/TokenStore';
import { System } from '../System';

export type FlightLoggerContext = {
  stepId?: string;
  userId?: string;
};

export class FlightLogger {
  resolver: Promise<FlightLogClient> | null;
  private tokenStore: TokenStore | null;
  private interval_id: NodeJS.Timeout | number | null;
  private action_buffer: flight_log_types.SignupAction[];
  private system: System;
  context: FlightLoggerContext | null;

  constructor(system: System, store: { tokenStore: TokenStore }) {
    this.resolver = null;
    this.interval_id = null;
    this.tokenStore = store.tokenStore;
    this.action_buffer = [];
    this.system = system;
    this.start();
    this.context = null;
  }

  start() {
    this.interval_id = setInterval(() => {
      this.flush();
    }, 1000);
  }

  setContext(context: Partial<FlightLoggerContext>) {
    this.context = { ...this.context, ...context };
  }

  async getClient(): Promise<FlightLogClient | null> {
    const token = this.tokenStore?.token;
    if (!token) {
      throw new Error('No user set');
    }
    if (!this.resolver && token) {
      this.resolver = new Promise<FlightLogClient>(async (resolve) => {
        const hubClient = this.system.clientProvisioner.provisionHubClientFromTrialToken(token);
        const userToken = await hubClient.provisionUserToken();
        if (!userToken?.token) {
          throw new Error('Unable to retrieve a userToken');
        }
        resolve(this.system.clientProvisioner.provisionFlightLogClient(userToken.token));
      });
    }
    return this.resolver;
  }

  async logAction(action: Omit<flight_log_types.SignupAction, 'service_name' | 'user_id' | 'timestamp' | 'meta'>) {
    const timestamp = new Date().toISOString();

    this.action_buffer.push({
      ...action,
      timestamp: timestamp,
      user_id: this.context?.userId || 'unknown',
      service_name: 'accounts-portals',
      meta: {
        step_id: this.context?.stepId || 'signup'
      }
    });
  }

  async flush() {
    const actions = this.action_buffer;
    this.action_buffer = [];
    if (actions.length === 0) {
      return;
    }
    const client = await this.getClient();
    if (!client) {
      return;
    }
    client.logSignupActions({
      actions: actions
    });
  }
}
